import { paymentsDuckCreator } from 'axl-ducks';
import { WalletStorageService } from 'wallet-manager';
import { PaymentCalculationFetcher } from '@syndicated-wallet/helpers/fetchers';

export default paymentsDuckCreator({
    store: 'payments',
    paymentFetcher: PaymentCalculationFetcher,
    walletStorageService: new WalletStorageService({
        environment: process.env.ENVIRONMENT,
    }),
});
